module.exports = __webpack_public_path__ + "img/setup-1.3de7ebf7.png";